import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "lola-framework-ui-test";
import { APP_ROUTES, TITLE_COLOR } from "../constants";
import { AuraLayout } from "../components/AuraLayout";
import { useStore } from "../store/globalState";
import { useSmsConsentStore } from "../store/useSmsConsentStore";
import { TermsMarkdown } from "../components/terms/TermsMarkdown";
import { trackScreenView } from "../analytics";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";
import { Navbar } from "../components/Navbar";

/**
 * SMS message policy. Same shell as a Terms & Conditions detail page. Back
 * returns to the page under the consent popup, which is still pending.
 */
export const SmsTermsPage = () => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy } = colorConfig;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const pending = useSmsConsentStore((s) => s.pending);

  useEffect(() => {
    trackScreenView("sms_terms_detail");
  }, []);

  if (!pending) {
    return <Navigate to={APP_ROUTES.HOME_PAGE} replace />;
  }

  const entry = pending.entries[0];
  const title = entry?.detailTitle || t("smsConsent.detailTitle");

  return (
    <AuraLayout colorConfig={colorConfig} className="term-detail-page">
      <Layout.Header>
        <Navbar
          onBackClick={() => navigate(-1)}
          title={title}
          align="center"
          color={TITLE_COLOR}
        />
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <ScrollFadeIndicator color={bodyCopy} />
        <section className="term-detail-wrapper" style={{ color: bodyCopy }}>
          {entry?.detailMarkdown ? (
            <TermsMarkdown content={entry.detailMarkdown} />
          ) : (
            <p className="muted-foreground">{t("terms.notFound")}</p>
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
};
